/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AlignHorizontalJustifyStart = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2" }],
    ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2" }],
    ["path", { d: "M2 2v20" }]
  ]
];

export { AlignHorizontalJustifyStart as default };
//# sourceMappingURL=align-horizontal-justify-start.js.map
